import { createSlice } from '@reduxjs/toolkit';

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        basicDetail: {},
    },
    reducers: {
        setProfileBasicDetail: (state, action) => {
            state.basicDetail = action.payload;
        },
    },
});

export const { setProfileBasicDetail } = profileSlice.actions;
export default profileSlice.reducer;